import { render, staticRenderFns } from "./GatewayIcon.vue?vue&type=template&id=5378cc84&scoped=true&"
import script from "./GatewayIcon.vue?vue&type=script&lang=js&"
export * from "./GatewayIcon.vue?vue&type=script&lang=js&"
import style0 from "./GatewayIcon.vue?vue&type=style&index=0&id=5378cc84&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5378cc84",
  null
  
)

export default component.exports